module.exports = {
  'en': {
    'HRESS3UC1': {
      '0': '[HRESS3U] Approve Change Of P/F Contribution',
      '10': '[HRESS3U] Approve Change Of P/F Contribution',
      '20': 'No.',
      '30': 'Employee Code',
      '40': 'Employee Name',
      '50': 'Request Date',
      '55': 'Seq. No.',
      '60': 'Approve Status',
      '70': 'Approve by',
      '80': 'Approve Date',
      '90': 'Remarks',
      '100': 'Next Approve'
    },
    'HRESS3UC2': {
      '0': 'Detail For Approve',
      '10': 'Employee :',
      '20': 'Seq. no :',
      '30': 'Approve by :',
      '40': 'Approve Date :',
      '50': 'Effective Date :',
      '60': 'Current Status :',
      '70': 'Status :',
      '80': 'Approve',
      '90': 'No Approve',
      '100': 'Remark :'
    },
    'HRESS3UC3': {
      '0': 'Member Information',
      '10': 'Member Information',
      '20': 'Employee',
      '30': 'Name',
      '40': 'Member ID',
      '50': 'Membership date',
      '60': 'Status',
      '70': 'Current',
      '80': 'Resign',
      '90': 'Resign  Date',
      '100': 'Remark',
      '110': 'Contribution Rate:',
      '120': 'Change Date',
      '140': 'Investment',
      '150': 'Effective Date',
      '160': 'Policy Code',
      '170': 'Detail',
      '180': 'Proportion',
      '190': 'Total'
    },
    'HRESS3UC4': {
      '0': 'List of Beneficiary',
      '10': 'List of Beneficiary',
      '20': 'No.',
      '30': 'Name',
      '40': 'Address',
      '50': 'Relation',
      '60': 'Inherit Rate %'
    }
  },
  'th': {
    'HRESS3UC1': {
      '0': '[HRESS3U] อนุมัติการแก้ไขกองทุนสำรองเลียงชีพ',
      '10': '[HRESS3U] อนุมัติการแก้ไขกองทุนสำรองเลียงชีพ',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ-นามสกุล',
      '50': 'วันที่ขอ',
      '55': 'ลำดับที่',
      '60': 'สถานะการอนุมัติ',
      '70': 'ผู้อนุมัติ',
      '80': 'วันที่อนุมัติ',
      '90': 'หมายเหตุการอนุมัติ',
      '100': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRESS3UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน :',
      '20': 'ลำดับที่อนุมัติ :',
      '30': 'รหัสผู้อนุมัติ :',
      '40': 'วันที่อนุมัติ :',
      '50': 'วันที่มีผล :',
      '60': 'สถานะปัจจุบัน :',
      '70': 'สถานะ :',
      '80': 'อนุมัติ',
      '90': 'ไม่อนุมัติ',
      '100': 'หมายเหตุ :'
    },
    'HRESS3UC3': {
      '0': 'รายละเอียดสมาชิก',
      '10': 'รายละเอียดสมาชิก',
      '20': 'พนักงาน',
      '30': 'ชื่อกองทุน',
      '40': 'เลขที่สมาชิก',
      '50': 'วันที่เป็นสมาชิก',
      '60': 'สถานะ',
      '70': 'ปัจจุบัน',
      '80': 'ลาออก',
      '90': 'วันที่ลาออก',
      '100': 'หมายเหตุ',
      '110': 'อัตราการหักเงินสะสมส่วนของพนักงาน',
      '120': 'วันที่มีผลบังคับใช้',
      '140': 'สัดส่วนการลงทุน',
      '150': 'วันที่มีผลบังคับใช้',
      '160': 'รหัสนโยบาย',
      '170': 'รายละเอียด',
      '180': 'สัดส่วน',
      '190': 'รวม'
    },
    'HRESS3UC4': {
      '0': 'ข้อมูลผู้รับประโยชน์',
      '10': 'ข้อมูลผู้รับประโยชน์',
      '20': 'ลำดับที่',
      '30': 'ชื่อ',
      '40': 'ที่อยู่',
      '50': 'ความสัมพันธ์',
      '60': 'ผลประโยชน์ %'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hress3u.js